// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_AT_RULE_IMPORT_0___ = require("-!../../../../../../node_modules/css-loader/dist/cjs.js??clonedRuleSet-9.use[1]!../../../../../../public/assets/css/shop/mangaplusgoods/printimage.css");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.overlay-wrapper[data-v-0e7465cc] {
  position: relative;
  /*display: inline-block;*/
  z-index: auto;
}
.overlay-wrapper.zoomed[data-v-0e7465cc] {
  z-index: 999;
}
.overlay-inner[data-v-0e7465cc] {
  position: relative;
  overflow: visible;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 0;
  left: 0;
  width: auto;
  height: auto;
  translate: 0 0;
  /*transition: translate 0.3s linear;*/
}
.overlay-area[data-v-0e7465cc] {
  display: none;
  z-index: 0;
}
.overlay-wrapper.zoomed .overlay-area[data-v-0e7465cc] {
  display: block;
}
.overlay-wrapper.zoomed .overlay-inner[data-v-0e7465cc] {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  max-width: 720px;
  max-height: 50vh;
  translate: 0 50%;
}
.overlay-image[data-v-0e7465cc] {
  cursor: zoom-in;
  z-index: auto;
}
.overlay-wrapper.zoomed .overlay-image[data-v-0e7465cc] {
  z-index: 1;
}
@media (min-width: 768px) {
.overlay-wrapper.zoomed .overlay-inner[data-v-0e7465cc] {
    translate: 50% 50%;
}
}
.overlay-bg[data-v-0e7465cc] {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: #222;
  opacity: 0;
  transition: ease 0.28s;
  pointer-events: none;
  z-index: -1;
}
.overlay-wrapper.zoomed .overlay-bg[data-v-0e7465cc] {
  opacity: 0.24;
  pointer-events: auto;
}
.zoom-icon[data-v-0e7465cc] {
  position: absolute;
  right: 0;
  bottom: 0;
  color: #888;
  transition: ease 0.28s;
  z-index: 2;
}
.overlay-wrapper.zoomed .zoom-icon[data-v-0e7465cc] {
  color: #202020;
  right: 10px;
  font-size: 2em;
}
`, "",{"version":3,"sources":["webpack://./src/vue/components/common/imageOverlayZoom.vue"],"names":[],"mappings":";AA4GA;EACA,kBAAA;EACA,yBAAA;EACA,aAAA;AACA;AACA;EACA,YAAA;AACA;AACA;EACA,kBAAA;EACA,iBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,qCAAA;AACA;AACA;EACA,aAAA;EACA,UAAA;AACA;AACA;EACA,cAAA;AACA;AACA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,aAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;AACA;AACA;EACA,eAAA;EACA,aAAA;AACA;AACA;EACA,UAAA;AACA;AACA;AACA;IACA,kBAAA;AACA;AACA;AAEA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,UAAA;EACA,sBAAA;EACA,oBAAA;EACA,WAAA;AACA;AACA;EACA,aAAA;EACA,oBAAA;AACA;AACA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,sBAAA;EACA,UAAA;AACA;AACA;EACA,cAAA;EACA,WAAA;EACA,cAAA;AACA","sourcesContent":["<template>\n  <div class=\"overlay-wrapper\" :class=\"{ zoomed: zoomed }\">\n    <div class=\"overlay-bg\" @click=\"toggleZoom\"></div>\n    <div class=\"overlay-area\" :style=\"areaStyle\"></div>\n    <div class=\"overlay-inner\">\n      <div\n        ref=\"image\"\n        class=\"mp-print-image overlay-image\"\n        :data-product=\"productType\"\n        :data-color=\"productColor\"\n        @click=\"toggleZoom\"\n      >\n        <img :src=\"front\" class=\"mp-print-image__printing\" alt=\"\" />\n      </div>\n      <i\n        class=\"zoom-icon\"\n        :class=\"{ 'icon-zoom-in': !zoomed, 'icon-zoom-out': zoomed }\"\n      ></i>\n    </div>\n  </div>\n</template>\n\n<script>\nexport default {\n  name: 'ImageOverlayZoom',\n\n  props: {\n    skuNo: { type: String, required: true },\n    front: { type: String, required: true } // 前面画像URL\n  },\n\n  data() {\n    return {\n      zoomed: false,\n      areaRect: {}\n    };\n  },\n\n  watch: {\n    zoomed(bool) {\n      document.querySelector('html').classList.toggle('is-fixed', bool);\n    }\n  },\n\n  computed: {\n    areaStyle() {\n      return {\n        width: this.areaRect.width,\n        height: this.areaRect.height\n      };\n    },\n\n    productType() {\n      return this.skuNo.split('-')[0];\n    },\n\n    productColor() {\n      return this.skuNo.split('-')[1];\n    }\n  },\n\n  mounted() {\n    const rect = this.$refs.image.getBoundingClientRect();\n    this.areaRect = {\n      width: `${rect.width}px`,\n      height: `${rect.height}px`\n    };\n  },\n\n  methods: {\n    toggleZoom() {\n      if (!this.zoomed) {\n        this.zoomIn();\n      } else {\n        this.zoomOut();\n      }\n    },\n\n    zoomIn() {\n      // 既に拡大中の場合は計算しない\n      if (this.zoomed) {\n        return;\n      }\n\n      this.zoomed = true;\n    },\n\n    zoomOut() {\n      this.zoomed = false;\n    }\n  }\n};\n</script>\n\n<style>\nhtml.is-fixed,\nhtml.is-fixed body {\n  height: 100%;\n  overflow: hidden;\n}\nhtml.is-fixed .p-global-header-wrapper,\nhtml.is-fixed .p-global-header {\n  z-index: 0;\n}\n</style>\n<style scoped>\n@import '@built-css/shop/mangaplusgoods/printimage.css';\n\n.overlay-wrapper {\n  position: relative;\n  /*display: inline-block;*/\n  z-index: auto;\n}\n.overlay-wrapper.zoomed {\n  z-index: 999;\n}\n.overlay-inner {\n  position: relative;\n  overflow: visible;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  top: 0;\n  left: 0;\n  width: auto;\n  height: auto;\n  translate: 0 0;\n  /*transition: translate 0.3s linear;*/\n}\n.overlay-area {\n  display: none;\n  z-index: 0;\n}\n.overlay-wrapper.zoomed .overlay-area {\n  display: block;\n}\n.overlay-wrapper.zoomed .overlay-inner {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  max-width: 720px;\n  max-height: 50vh;\n  translate: 0 50%;\n}\n.overlay-image {\n  cursor: zoom-in;\n  z-index: auto;\n}\n.overlay-wrapper.zoomed .overlay-image {\n  z-index: 1;\n}\n@media (min-width: 768px) {\n  .overlay-wrapper.zoomed .overlay-inner {\n    translate: 50% 50%;\n  }\n}\n\n.overlay-bg {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  background-color: #222;\n  opacity: 0;\n  transition: ease 0.28s;\n  pointer-events: none;\n  z-index: -1;\n}\n.overlay-wrapper.zoomed .overlay-bg {\n  opacity: 0.24;\n  pointer-events: auto;\n}\n.zoom-icon {\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  color: #888;\n  transition: ease 0.28s;\n  z-index: 2;\n}\n.overlay-wrapper.zoomed .zoom-icon {\n  color: #202020;\n  right: 10px;\n  font-size: 2em;\n}\n</style>\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
